import { Box, Container, Stack } from '@mui/material';
import { memo } from 'react';
import useInspection from 'hooks/useInspection';
import PositiveButton from 'components/cmn/PositiveButton';

interface IClassificationGuide3NextGroupProps {
  next: number;
  total: number;
}
function ClassificationGuide3NextGroup({ next, total }: IClassificationGuide3NextGroupProps): JSX.Element {
  const { changeObjectKeyIndex, changeDetailProgressInfo } = useInspection();
  const handleNextClassification = async () => {
    // next는 다음 그룹의 인덱스 (0-based)
    await changeObjectKeyIndex(next);
    await changeDetailProgressInfo(0);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        py: 4,
      }}
    >
      <Box
        sx={{
          p: 4,
          width: '100%',
          maxWidth: { xs: '100%', md: '1536px' },
          height: { xs: 'auto', md: '864px' },
        }}
      >
        <Container maxWidth="xl" sx={{ height: 'calc(100%)' }}>
          <Container maxWidth="lg" sx={{ p: 0, height: 'calc(100% - 84px)' }}>
            <Stack
              direction="column"
              justifyContent="center"
              alignContent="center"
              alignItems="center"
              sx={{ height: '100%' }}
            >
              <Box
                sx={{
                  fontSize: { xs: '19px', sm: '48px', md: '52px' },
                  fontWeight: 900,
                  textAlign: 'center',
                }}
              >
                다음 그룹을 분류합니다. ({next + 1}/{total})
              </Box>
            </Stack>
          </Container>
        </Container>
      </Box>
      {/* 하단 버튼 영역 높이만큼 여백 추가 (버튼 높이 52px + 패딩 32px = 약 84px) */}
      <Box sx={{ height: { xs: 84, sm: 84 } }} />
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          bgcolor: 'background.paper',
          boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
          py: 2,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PositiveButton
          variant="contained"
          onClick={handleNextClassification}
          sx={{ width: { xs: 130 }, height: 52, typography: 's14w500' }}
          title="시작"
        />
      </Box>
    </Box>
  );
}

export default memo(ClassificationGuide3NextGroup);
